import {
  Box,
  FormControlLabel,
  Paper,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import ControlSlider from "./ControlSlider";

export default function ControlPanel({
  curve,
  fontSize,
  onCurveChange,
  onFontSizeChange,
  onRotateChange,
  onSpaceSizeChange,
  onTextChange,
  rotate,
  spaceSize,
  text,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, sm: 2.5, md: 3 },
        borderRadius: { xs: 3, sm: 4 },
        border: (theme) => `1px solid ${theme.palette.outline?.main}`,
      }}
    >
      <Stack spacing={2.25}>
        <Box>
          <Typography variant="overline" color="text.secondary">
            Controls / 编辑参数
          </Typography>
          <Typography variant="h5" sx={{ mt: 0.25 }}>
            Tune your sticker text
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
            保留原本逻辑，只把常用参数整理成更清晰的编辑面板。
          </Typography>
        </Box>

        <ControlSlider
          title="Rotation"
          subtitle="微调文字倾斜角度，让它更像原生贴纸排版"
          value={rotate}
          min={-10}
          max={10}
          step={0.2}
          onChange={onRotateChange}
          valueFormatter={(current) => current.toFixed(1)}
        />

        <ControlSlider
          title="Font size"
          subtitle="放大或缩小标题，兼顾视觉冲击和留白"
          value={fontSize}
          min={10}
          max={100}
          step={1}
          onChange={onFontSizeChange}
          valueFormatter={(current) => `${current}px`}
        />

        <ControlSlider
          title="Spacing"
          subtitle="主要影响多行文本间距，单行文本变化会更轻微"
          value={spaceSize}
          min={18}
          max={100}
          step={1}
          onChange={onSpaceSizeChange}
          valueFormatter={(current) => `${current}px`}
        />

        <Paper
          variant="outlined"
          sx={{
            p: 2.25,
            borderRadius: 3,
            backgroundColor: (theme) => theme.palette.surface?.elevated,
          }}
        >
          <Stack spacing={1}>
            <FormControlLabel
              control={<Switch checked={curve} onChange={onCurveChange} />}
              label={
                <Stack spacing={0.25}>
                  <Typography variant="subtitle1" fontWeight={700}>
                    Curved text
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    打开后会切换成弧形排版，并沿用当前贴纸的绘制规则
                  </Typography>
                </Stack>
              }
              sx={{
                alignItems: "flex-start",
                m: 0,
                gap: 1.25,
              }}
            />
          </Stack>
        </Paper>

        <TextField
          label="Text"
          helperText="支持 multiline 文本；主标签保留英文，中文只做说明。"
          value={text}
          onChange={onTextChange}
          multiline
          minRows={4}
          fullWidth
        />
      </Stack>
    </Paper>
  );
}
